export class GnssConfiguration {
  description!: string;
  type!:string;
  latColumnName?:string;
  lngColumnName?:string;
  latitude?:string;
  longitude?:string;
  templateId!:string;
  order!:string;

}
